export default __webpack_public_path__ + "static/step2-a4dc7d0fdcc5c73c2a3cad2405d892b9.jpg";